import React from "react";
import "./QuickStatsModal.scss";

import UniversalButton from "components/uiComponents/UniversalButton";
import QuickStatsTable from "./QuickStatsTable";
import {ReactComponent as CopyIcon} from "../../../static/icons/copy-icon.svg";
import toast from "react-hot-toast";
import Toast from "../../Toasts/Toast";
import CopyToast from "../../Toasts/CopyToast";

const QuickStatsModal = ({
  title,
  data,
  closeModal,
}) => {

  const handleCancel = () => {
    closeModal?.();
  };

  const headerData = (table) => {
    const columnDataArr = [];
    let counter = 0;

    for (let key in table) {
      if (counter === 0) {
        columnDataArr.push({
          name: 'category',
          value: 'Category',
        });

        table[key].forEach(item => {
          columnDataArr.push({
            name: item.name.toLowerCase(),
            value: item.name,
          })
        });

        counter++;
      }
    }

    columnDataArr.push({
      name: 'copy',
      value: '',
    })

    return columnDataArr;
  }

  const rowData = (table) => {
    const rowDataArr = [];

    for (let key in table) {
      const itemObj = {};

      itemObj.category = {
        name: key,
        unit: null,
        value: key,
        visibleValue: key,
      };

      table[key].forEach(item => {
        let visibleValue = item.value;
        const unitArr = item?.unit?.split('^');

        if (typeof visibleValue === 'number') {
          if (item.value % 1 !== 0) {
            visibleValue = item.value.toFixed(2);
            const visibleValueArr = visibleValue.split('.');

            if (visibleValueArr?.[1] === '00') {
              visibleValue = visibleValueArr[0];
            }
          }
        }

        itemObj[item.name.toLowerCase()] = {
          name: item.name.toLowerCase(),
          unit: unitArr?.[0],
          unitDegree: unitArr?.[1],
          value: item.value,
          visibleValue,
        };
      });

      itemObj.copy = {
        name: 'copy',
        unit: null,
        value: null,
        visibleValue: null,
      };

      rowDataArr.push(itemObj);
    }

    return rowDataArr;
  };

  const footerData = (table) => {
    const footerDataArr = [];
    let counter = 0;

    for (let key in table) {
      if (counter === 0) {
        footerDataArr.push({
          name: 'category',
          value: 'Total',
          visibleValue: data.length > 1 ? "Sub total" : "Total",
          unit: null,
        });

        table[key].forEach(item => {
          const name = item.name.toLowerCase();
          let newObj = {};
          let visibleValue = null;

          rowData(table).forEach(row => {
            if (typeof row[name].value === 'number') {
              let cellName = null;
              let cellValue = null;
              let cellUnit = null;
              let cellUnitDegree = null;

              if (newObj?.name) {
                cellName = newObj.name;
              } else if (row[name]?.name || row[name]?.name === 0) {
                cellName = row[name].name;
              }

              if (newObj?.unit) {
                cellUnit = newObj.unit;
              } else if (row[name]?.unit) {
                cellUnit = row[name].unit;
              }

              if (newObj?.unitDegree) {
                cellUnitDegree = newObj.unitDegree;
              } else if (row[name]?.unitDegree) {
                cellUnitDegree = row[name].unitDegree;
              }

              if (newObj?.value || newObj?.value === 0) {
                cellValue = newObj.value + row[name].value;
              } else {
                cellValue = row[name]?.value;
              }

              newObj = {
                unit: cellUnit,
                unitDegree: cellUnitDegree,
                name: cellName,
                value: cellValue,
              };
            }
          });

          if (typeof newObj.value === 'number') {
            if (newObj.value % 1 !== 0) {
              visibleValue = newObj.value.toFixed(2);
              const visibleValueArr = visibleValue.split('.');

              if (visibleValueArr?.[1] === '00') {
                visibleValue = visibleValueArr[0];

                newObj.visibleValue = visibleValue;
              } else {
                newObj.visibleValue = visibleValue;
              }
            } else {
              newObj.visibleValue = newObj.value;;
            }
          } else {
            newObj.visibleValue = newObj.value;
          }

          footerDataArr.push(newObj);
        });

        counter++;
      }
    }

    footerDataArr.push({
      name: 'copy',
      value: '',
      showValue: '',
      unit: null,
    })

    return footerDataArr;
  };

  const handleCopyCellClicked = (arr) => {
    const rowStringsArr = [];

    arr.forEach(element => {
      rowStringsArr.push(element.visibleValue)
    });

    rowStringsArr.pop();

    const dataClipboardtext = rowStringsArr.join('\t');

    navigator.clipboard.writeText(dataClipboardtext);

    toast((t) => (
        <Toast
          {...t}
        >
          <CopyToast />
        </Toast>
      ),
      {
        duration: 2000,
      }
    );
  };

  const getTablesTotalObject = () => {
    const categories = data.map((el) => {
      return Object.values(el.sumCategories);
    })
    return Object.assign({}, categories);
  }

  return (
    <div className="quick-stats-modal">
      {!!title &&
        <h2>{title}</h2>
      }

      <div className="quick-stats-modal__body">
        {
          data.map((el, index) => {
            return (
              <QuickStatsTable table={el}
                               data={data}
                               headerData={headerData}
                               rowData={rowData}
                               footerData={footerData}
                               handleCopyCellClicked={handleCopyCellClicked}
                               getTablesTotalObject={getTablesTotalObject}
                               key={index}/>
            )
          })
        }
      </div>
      {
        data.length > 1 &&
        <div className="quick-stats-modal__tables-total">
          {footerData(getTablesTotalObject()).map((item, index) => {
            const handleCopyClick = () => {
              handleCopyCellClicked(footerData(getTablesTotalObject()));
            };

            if (item.name === 'copy') {
              return (
                <div
                  key={`footer-${index}`}
                  className="quick-stats-modal__table_footer-item quick-stats-modal__table_footer-item-copy"
                  onClick={handleCopyClick}
                >
                  <div className="quick-stats-modal__table_copy-icon-container">
                    <CopyIcon className="quick-stats-modal__table_copy-icon"/>
                  </div>
                </div>
              );
            } else {
              return (
                <div
                  key={`footer-${index}`}
                  className="quick-stats-modal__table_footer-item"
                >
                  <div className="quick-stats-modal__table_row-item-unit-container">
                    {
                      item.name === "category" ?
                        <span>Total</span> :
                        <span>{item.visibleValue}</span>
                    }
                    {
                      item.value !== "Total" &&
                      <div className="quick-stats-modal__table_row-item-unit-container">
                        &nbsp;
                        {item?.unit &&
                          <span className="quick-stats-modal__table_row-item-unit">
                            {item?.unit}
                          </span>
                        }

                        {item?.unitDegree &&
                          <span className="quick-stats-modal__table_row-item-unit-degree">
                            {item?.unitDegree}
                          </span>
                        }
                      </div>
                    }
                  </div>
                </div>
              );
            }
          })}
        </div>
      }
      <div className="quick-stats-modal__btns">
        <div className="quick-stats-modal__btns_btn">
          <UniversalButton
            type="button"
            label="Close"
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="blue-light"
            onClick={handleCancel}
          />
        </div>
      </div>
    </div>
  );
};

export default QuickStatsModal;
